export default (
    [
        { // th
            Orderers: 'ผู้จ้าง',
            Cutdirections: 'ทิศทางตัด',
            SlabsTypes: 'ประเภทแผ่นหิน',
            Duedate: 'วันครบกำหนด',
            warehouses: 'คลัง',
            buyfroms: 'สถานที่ซื้อ',
            productsgrade: 'เกรดสินค้า',
            ItemNumbers: 'รายการเลขที่',
            Currencys: '73.สกุลเงิน',
            Locations2: '72.สถานที่',
            Projects: '71.โครงการ',
            ProductsGrade: '23.ระดับสินค้า',
            ChartOfAccount: 'ผังบัญชี',
            Selected: 'เลือก',
            Notfound: 'ไม่พบรายการ',
            Inputs: 'เติม',
            Prints: 'ปริ้นท์',
            Grids: 'ตาราง',
            Fields: 'Field',
            Titles: 'หัวข้อ',
            columns: 'คอลัมน์',
            documentdate: 'วันที่เอกสาร',
            referencedate: 'วันที่อ้างอิง',
            expressnumber: 'เลขที่ Express',
            ReceiveDate: 'วันรับของ',
            SettingForms: 'B.กำหนดแบบฟอร์ม',
            SettingFormsBuy: '1.กำหนดแบบฟอร์มซื้อ',
            SettingFormsSell: '2.กำหนดแบบฟอร์มขาย',
            SettingFormsCredit: '3.กำหนดแบบฟอร์มซื้อเงินเชื่อ',
            SettingFormSellCredits: '4.กำหนดแบบฟอร์มขายเงินเชื่อ',
            Qtyunits: '20.หน่วยสินค้า',
            Paymenttypes: '70.เงื่อนไขการชำระเงิน',
            Vtypes: '74.ประเภทราคา',
            Custypes: '75.ประเภทลูกค้า',
            Buyfroms: '80.สถานที่ซื้อ',
            Transmode: '41.ขนส่งโดย',
            WhtMode: '55.หมวดภาษีหัก ณ ที่จ่าย',
            Titlepos: 'คำนำหน้าชื่อ',
            Costs: 'ต้นทุน',
            Returns: 'คืน',
            Cumulative: 'สะสม',
            Debits: 'เดบิต',
            Credits: "เครดิต",
            Depreciation: 'ค่าเสื่อม',
            Assets: 'ทรัพย์สิน',
            Cheque: 'เช็ค',
            Deadline: 'วันเกินกำหนด',
            Remarks: 'หมายเหตุ',
            Generals: 'ทั่วไป',
            Changed: 'เปลี่ยน',
            Banks: 'ธนาคาร',
            Formats: 'รูปแบบ',
            Decimals: 'ทศนิยม',
            Multiplys: 'คูณ',
            Periods: 'ช่วง',
            Show: 'แสดง',
            Hide: 'ซ่อน',
            Save: 'บันทึก',
            Phone: 'โทรศัพท์',
            English: 'อังกฤษ',
            Chinese: 'จีน',
            Thai: 'ไทย',
            Company: "บริษัท",
            CompanysTypes: 'ประเภทกิจการ',
            SettingStarts: '1.กำหนดค่าเริ่มต้นต่างๆ',
            SettingTables: '2.กำหนดตารางข้อมูล',
            SettingFinrounds: '3.กำหนดรอบบัญชี',
            SettingDocuments: '4.กำหนดเลขที่เอกสาร',
            SettingFincons: '5.กำหนดการเชื่อมต่อบัญชี',
            SettingDepts: '6.กำหนดแผนก',
            SettingNewcoms: '7.กำหนดบริษัทใหม่',
            SettingMessages: '8.รายการข้อความ',
            SettingMessagesGeneral: '1.รายละเอียดทั่วไป',
            SettingMessagesVendor: '2.เจ้าหนี้',
            SettingMessagesCustomer: '3.ลูกค้า',
            SettingMessagesBank: '4.ธนาคาร',
            SettingMessagesVat: '5.ภาษี',
            SettingMessagesProduct: '6.สินค้า',
            SettingMessagesFinance: '7.บัญชี',
            SettingStartsCompany: '1.รายละเอียดกิจการ',
            SettingStartsGeneral: '2.เรื่องทั่วไป',
            SettingStartsStockRemains: '3.ระบบสินค้าคงเหลือ',
            SettingStockRemains: '2.กลุ่มบัญชีสินค้า',
            SettingStartsSellandCustomer: '4.ระบบขายและลูกหนี้',
            SettingStartVendorMethod: '2.วิธีการชำระหนี้',
            SettingStartsBuyandSuppliers: '5.ระบบซื้อและเจ้าหนี้',
            SettingStartsBanks: '6.ระบบการเงินและการธนาคาร',
            SettingStartsFin: '7.ระบบบัญชี',
            SettingStartsAssets: '8.ระบบทรัพย์สิน',
            SettingAssets: '2.กลุ่มบัญชีทรัพย์สิน',
            GeneralsDetails: '1.รายละเอียดทั่วไป',
            Productday: '1. รายการประจำวันสินค้า',
            ProductTransfer: '3.โอนย้ายระหว่างคลัง',
            ProductAdj: '4.ปรับปรุงยอดสินค้า',
            ProductCost: '5.ปรับปรุงต้นทุนสินค้า',
            SettingStartsBanksDetail: 'รายละเอียดธนาคาร',
            SettingStartsBanksName: 'ชื่อธนาคาร',
            Account: 'บัญชี',
            Values: 'ค่า',
            Purchase: 'ซื้อ',
            deposit: 'จ่ายมัดจำ',
            PurchaseOrderNumber: 'เลขที่ใบสั่งซื้อ',
            PurchaseOrder: 'ใบสั่งซื้อ',
            PurchaseCredit: 'ซื้อเงินเชื่อ',
            PurchaseAndOrder: 'คำสั่งซื้อ/คำสั่ง',
            Ports: 'ท่าเรือ',
            Countrys: 'ประเทศ',
            Terms: 'เทอม',
            Agents: 'ตัวแทน',
            Search: 'ค้นหา',
            Modes: 'หมวด',
            Modessub: 'หมวดย่อย',
            Modessubmore: 'หมวดย่อยเสริม',
            Choose: 'เลือก',
            Supplier: 'ผู้จำหน่าย',
            SupplierDetails: 'รายละเอียดผู้จำหน่าย',
            Cash: 'เงินสด',
            Credit: 'เงินเชื่อ',
            Price: 'ราคา',
            Details: 'รายละเอียด',
            Buy: 'ซื้อ',
            Sell: 'ขาย',
            SellCredits: 'ขายเงินเชื่อ',
            Day: 'วัน',
            Month: 'เดือน',
            Year: 'ปี',
            Balance: 'สมดุล',
            Decrease: 'ลด',
            Increase: 'เพิ่ม',
            Slabsfinalstransreport: 'B.สรุปยอดเคลื่อนไหวสินค้าบล็อค',
            SlabsfinalstransreportSlabs: 'สรุปยอดเคลื่อนไหวสินค้าสแลป',
            Slabstransreport: 'รายงานความเคลื่อนไหวหินแผ่น',
            Blockstransreport: 'รายงานความเคลื่อนไหวบล็อค',
            Report: 'รายงาน',
            startnum: 'เลขเริ่ม',
            complete: 'สำเร็จ',
            actions: 'กระทำการ',
            confirm: 'ยืนยัน',
            cancel: 'ยกเลิก',
            copy: 'คัดลอก',
            remain: 'คงเหลือ',
            scrub: 'ขัด',
            dissect: 'ผ่า',
            disscrub: 'ผ่าและขัด',
            updated_at: 'แก้ไขเมื่อ',
            gangsaw: 'เครื่องตัด',
            lost: 'สูญเสีย',
            BlocksCut: 'ตัดแบ่งบล็อค',
            slabscut: 'ตัดแบ่งแผ่นหิน',
            cut_round: 'ครั้งที่ตัด',
            import: 'นำเข้า',
            item: 'รายการ',
            origin: 'ต้นทาง',
            destination: 'ปลายทาง',
            types: 'ประเภท',
            billoflading: 'ใบตราส่งสินค้าทางเรือ',
            netweight: 'น้ำหนักสุทธิ',
            grossweight: 'น้ำหนักกรอส',
            marks: 'เครืองหมาย',
            invoice: 'ใบแจ้งหนี้',
            shipment: 'งาน',
            calculate: 'คำนวณ',
            customers: 'ลูกค้า',
            CustomerDetails: 'รายละเอียดลูกค้า',
            discount: 'ส่วนลด',
            unitprice: 'ราคาต่อหน่วย',
            WHT: 'หัก ณ ที่จ่าย',
            percent: 'เปอร์เซ็นต์',
            Vats: 'ภาษีมูลค่าเพิ่ม',
            units: 'หน่วย',
            unitsexc: 'หน่วยจริง',
            cbm: 'ลูกบาศก์เมตร',
            long: 'ยาว',
            width: 'กว้าง',
            height: 'สูง',
            old: 'เก่า',
            new: 'ใหม่',
            all: 'ทั้งหมด',
            normal: 'ปกติ',
            relation: 'ความสัมพันธ์',
            locations: 'สถานที่',
            qty: 'ปริมาณ',
            qtyexc: 'ปริมาณจริง',
            ata: 'วันสินค้าถึง',
            num_of_containers: 'จำนวนตู้',
            container_number: 'เบอร์ตู้',
            product_group: 'กลุ่มสินค้า',
            Block: 'บล็อค',
            Slab: 'แผ่นหิน',
            lang_po_type: 'ประเภทคำสั่งซื้อ',
            number: 'ตัวเลข',
            btn_list: 'รายการ',
            btn_add: 'เพิ่ม',
            btn_save: 'บันทึก',
            btn_edit: 'แก้ไข',
            btn_delete: 'ลบ',
            btn_submit: 'ตกลง',
            btn_reset: 'รีเซ็ต',
            btn_lock: 'ล็อก',
            btn_lock_unlock: 'ล็อค/ปลดล็อค',
            vendors: 'เจ้าหนี้',
            code: 'รหัส',
            name: 'ชื่อ',
            address: 'ที่อยู่',
            zcode: 'รหัสไปรษณีย์',
            editor: 'ผู้แก้ไข',
            branch: 'สาขา',
            taxid: 'เลขประจำตัวผู้เสียภาษี',
            created: 'สร้าง',
            profile: 'บัญชี',
            stock: 'สต็อค',
            logout: 'ออก',
            ask_delete: 'แน่ใจหรือไม่ว่าจะลบ?',
            ask_cancel: 'แน่ใจหรือไม่ว่าจะยกเลิก?',
            ask_complete: 'แน่ใจหรือไม่ว่าจะยืนยัน?',
            del_complete: 'ลบสำเร็จ',
            del_error: 'ลบผิดพลาด',
            confirm_error: 'ยืนยันผิดพลาด',
            copy_error: 'คัดลอกผิดพลาด',
            formvalid: 'กรุณากรอกข้อมูลให้ถูกต้อง',
            add_complete: 'บันทึกสำเร็จ',
            purchaseorder: 'ใบสั่งซื้อ',
            order: 'คำสั่ง',
            products: 'สินค้า',
            ProductsDetails: 'รายละเอียดสินค้า',
            ProductsNormal: '2.รายละเอียดสินค้า(มีสต็อค)',
            ProductsService: '3.รายละเอียดสินค้าบริการ(ไม่มีสต็อค)',
            producttypes: 'ชนิดสินค้า',
            RawMaterial: 'วัตถุดิบ',
            FinishedGoods: 'สินค้าสำเร็จ',
            contacts: 'ติดต่อ',
            payments_type: 'ประเภทการจ่าย',
            payments_types: 'เงื่อนไขการชำระเงิน',
            payments_number: 'เลขที่ชำระ',
            currency: 'สกุลเงิน',
            totalamount: 'ยอดเงินรวม',
            amount: 'ยอดเงิน',
            exchange: 'อัตราแลกเปลี่ยน',
            approver: 'ผู้อนุมัติ',
            authorizer: 'ผู้ลงนาม',
            authdate: 'วันอนุมัติ',
            term: 'เงื่อนไข',
            status: 'สถานะ',
            remark: 'หมายเหตุ',
            tbl_name: 'ฐานข้อมูล',
            credit: 'เครดิต',
            date: 'วันที่',
            arrival: 'มาถึง',
            document: 'เอกสาร',
            reference: 'อ้างอิง',
            poreport : ['1.เรียงตามเลขที่','2.เรียงตามวันที่','3.แยกตามผู้จำหน่าย','4.สินค้าค้างรับ แยกตามสินค้า',
            '5.สินค้าค้างรับ แยกตามใบสั่งซื้อ','6.สินค้าค้างรับ แยกตามผู้จำหน่าย','7.สินค้าถูกยกเลิก แยกตามสินค้า',
            '8.สินค้าถูกยกเลิก แยกตามใบสั่งซื้อ','9.สินค้าถูกยกเลิก แยกตามผู้จำหน่าย','A.สินค้าถูกยกเลิก แยกตามเหตุผล'],
        },
        { // cn
            Duedate: '截止日期',
            warehouses: '倉庫',
            buyfroms: '購買地點',
            productsgrade: '產品等級',
            ItemNumbers: '項目編號',
            Currencys: '73.貨幣',
            Locations2: '72.位置',
            Projects: '71.項目',
            ProductsGrade: '23.產品等級',
            ChartOfAccount: '會計科目表',
            Selected: '選擇',
            Notfound: '未找到',
            Inputs: '輸入',
            Prints: '打印',
            Fields: 'Field',
            Titles: '標題',
            columns: '柱',
            documentdate: '文件日期',
            referencedate: '參考日期',
            expressnumber: 'Express 數',
            ReceiveDate: '收到日期',
            SettingForms: 'B.表格設定',
            SettingFormsBuy: '1.購買表格設置',
            SettingFormsSell: '2.出售表格設置',
            SettingFormsCredit: '3.出售表格設置',
            Qtyunits: '20.數量單位',
            Paymenttypes: '70.支付方式',
            Transmode: '41.運輸',
            WhtMode: '55.持有稅',
            deposit: '1.存款',
            Titlepos: '名稱前綴',
            Costs: '成本',
            Returns: '返回',
            Cumulative: '累積的',
            Debits: '借方',
            Credits: "信用",
            Depreciation: '折舊',
            Assets: '資產',
            Cheque: '校驗',
            Deadline: '最後期限',
            Remarks: '備註',
            Generals: '一般',
            Changed: '更改',
            Banks: '銀行',
            Formats: '格式',
            Decimals: '小數',
            Multiplys: '乘',
            Periods: '期',
            Show: '顯示',
            Hide: '隱藏',
            Save: '救',
            Phone: '電話',
            English: '英語',
            Chinese: '中文',
            Thai: '泰國',
            Company: "公司",
            CompanysTypes: '公司類型',
            SettingStarts: '1.設置開始',
            SettingTables: '2.設置數據庫',
            SettingFinrounds: '3.設置融資回合',
            SettingDocuments: '4.設置文件',
            SettingFincons: '5.設置財務連接',
            SettingDepts: '6.設置部門',
            SettingNewcoms: '7.成立新公司',
            SettingMessages: '8.設定訊息',
            SettingMessagesGeneral: '1.一般',
            SettingMessagesVendor: '2.供應商',
            SettingMessagesCustomer: '3.顧客',
            SettingMessagesBank: '4.銀行',
            SettingMessagesVat: '5.增值稅',
            SettingMessagesProduct: '6.產品',
            SettingMessagesFinance: '7.金融',
            SettingStartsCompany: '1.公司資料',
            SettingStartsGeneral: '2.一般',
            SettingStartsStockRemains: '3.剩餘庫存',
            SettingStockRemains: '2.產品組',
            SettingStartsSellandCustomer: '4.銷售和客戶',
            SettingStartVendorMethod: '2.付款方法',
            SettingStartsBuyandSuppliers: '5.買和賣',
            SettingStartsBanks: '6.金錢和銀行',
            SettingStartsFin: '7.金融',
            SettingStartsAssets: '8.資產',
            SettingAssets: '2.組資產',
            GeneralsDetails: '1.一般',
            SettingStartsBanksDetail: '銀行明細',
            SettingStartsBanksName: '銀行名',
            Account: '帳戶',
            Values: '價值觀',
            Purchase: '採購',
            PurchaseOrderNumber: '訂購單號碼',
            PurchaseOrder: '採購訂單',
            PurchaseCredit: '採購 信用',
            PurchaseAndOrder: '採購訂單/訂購',
            Ports: '港口',
            Countrys: '國家',
            Terms: 'Term',
            Agents: '代理人',
            Search: '搜索',
            Modes: '模式',
            Modessub: '子模式',
            Modessubmore: '子模式 更多',
            Choose: '選擇',
            Supplier: '供應商',
            SupplierDetails: '供應商',
            Cash: '現金',
            Credit: '信用',
            Price: '價錢',
            Details: '詳情',
            Buy: '購買',
            Sell: '賣',
            Day: '天',
            Month: '月',
            Year: '年',
            Balance: '平衡',
            Decrease: '減少',
            Increase: '增加',
            Slabsfinalstransreport: '平板 橫切 完成',
            Slabstransreport: '平板 橫切',
            Blockstransreport: '塊 橫切',
            Report: '報告',
            startnum: '起始號碼',
            complete: '完成',
            actions: '行動',
            confirm: '確認',
            cancel: '取消',
            copy: '複製',
            remain: '保持',
            scrub: '擦洗',
            dissect: '解剖',
            disscrub: '解剖 擦洗',
            updated_at: '更新',
            gangsaw: '鋸',
            lost: '丟失',
            BlocksCut: '切割 塊',
            slabscut: '平板 切',
            cut_round: '切圓',
            import: '進口',
            item: '項目',
            origin: '起源',
            destination: '目的地',
            types: '類型',
            netweight: '淨重',
            grossweight: '總重量',
            marks: '標記',
            billoflading: '提貨單',
            invoice: '發票',
            shipment: '裝船',
            unitprice: '單價',
            customers: '顧客',
            discount: '折扣',
            WHT: '預扣稅',
            percent: '百分',
            Vats: '增值稅',
            calculate: '計算',
            units: '單位',
            unitsexc: '精確地單位',
            cbm: '立方體',
            long: '長',
            width: '寬度',
            height: '高度',
            old: '舊',
            new: '新',
            all: '所有',
            normal: '正常',
            relation: '關係',
            locations: '位置',
            qty: '數量',
            qtyexc: '準確數量',
            ata: '到達日期',
            num_of_containers: '貨櫃數量',
            container_number: '貨櫃號碼',
            product_group: '產品組',
            Block: '塊',
            Slab: '平板',
            lang_po_type: 'PO 類型',
            number: '数',
            btn_list: '清单',
            btn_save: '救',
            btn_add: '加',
            btn_edit: '编辑',
            btn_delete: '删除',
            btn_submit: '提交',
            btn_reset: '重启',
            btn_lock: '鎖',
            btn_lock_unlock: '鎖/開鎖',
            vendors: '供应商',
            code: '码',
            name: '名称',
            address: '地址',
            zcode: '邮政编码',
            editor: '编辑',
            branch: '科',
            taxid: '税号',
            created: '创建',
            profile: '轮廓',
            stock: '股票',
            logout: '登出',
            ask_delete: '您要删除吗?',
            ask_cancel: '你想取消嗎?',
            ask_complete: '你想完成嗎',
            del_complete: '删除完成',
            del_error: '删除错误',
            copy_error: '複製錯誤',
            confirm_error: '確認錯誤',
            formvalid: '请输入必填数据',
            add_complete: '保存完成',
            purchaseorder: '採購訂單',
            order: '訂購',
            products: '產品',
            ProductsDetails: '產品信息',
            ProductsNormal: '2.產品信息(Stock)',
            ProductsService: '3.產品信息(No Stock)',
            producttypes: '產品類別',
            RawMaterial: '原材料',
            FinishedGoods: '完成品',
            contacts: '聯繫',
            payments_types: '支付方式',
            payments_type: '付款方式',
            payments_number: '付款號碼',
            currency: '貨幣',
            totalamount: '總金額',
            amount: '量',
            exchange: '交換',
            approver: '批准者',
            authorizer: '授權人',
            authdate: '認證日期',
            term: '術語',
            status: '狀態',
            remark: '備註',
            credit: '信用',
            date: '日期',
            arrival: '到達',
            document: '文獻',
            reference: '參考',
        },
        { // en
            Duedate: 'Due Date',
            warehouses: 'Warehouse',
            buyfroms: 'Buy Location',
            productsgrade: 'Product Grade',
            ItemNumbers: 'Item Number',
            Currencys: '73.Currency',
            Locations2: '72.Location',
            Projects: '71.Project',
            ProductsGrade: '23.Product Grade',
            ChartOfAccount: 'Chart Of Account',
            Selected: 'Select',
            Notfound: 'Not Found',
            Inputs: 'Input',
            Prints: 'Print',
            Fields: 'Field',
            Titles: 'Title',
            columns: 'Column',
            documentdate: 'Document Date',
            referencedate: 'Reference Date',
            expressnumber: 'Express Number',
            ReceiveDate: 'Receive Date',
            SettingForms: 'B.Form Setting',
            SettingFormsBuy: '1.Form Setting BUY',
            SettingFormsSell: '2.FormSetting Sell',
            SettingFormsCredit: '3.FormSetting Credit',
            Qtyunits: '20.Unit Type',
            Paymenttypes: '70.Payment Type',
            Transmode: '41.Mode of Transport',
            WhtMode: '55.With holding tax Mode',
            deposit: '1.Deposit',
            Titlepos: 'Name prefix',
            Costs: 'Cost',
            Returns: 'Return',
            Cumulative: 'Cumulative',
            Debits: 'Debit',
            Credits: "Credit",
            Depreciation: 'Depreciation',
            Assets: 'Asset',
            Cheque: 'Cheque',
            Deadline: 'Deadline',
            Remarks: 'Remark',
            Generals: 'General',
            Changed: 'Change',
            Banks: 'Bank',
            Formats: 'Format',
            Decimals: 'Decimal',
            Multiplys: 'Multiply',
            Periods: 'Period',
            Show: 'Show',
            Hide: 'Hide',
            Save: 'Save',
            Phone: 'Phone',
            English: 'English',
            Chinese: 'Chinese',
            Thai: 'Thai',
            Company: "Company",
            CompanysTypes: 'Company Type',
            SettingStarts: '1.Setting Start',
            SettingTables: '2.Setting Database',
            SettingFinrounds: '3.Setting Finance Round',
            SettingDocuments: '4.Setting Document',
            SettingFincons: '5.Setting Finance Connect',
            SettingDepts: '6.Setting Department',
            SettingNewcoms: '7.Setting New Company',
            SettingMessages: '8.Setting Message',
            SettingMessagesGeneral: '1.General',
            SettingMessagesVendor: '2.Vendor',
            SettingMessagesCustomer: '3.Customer',
            SettingMessagesBank: '4.Bank',
            SettingMessagesVat: '5.VAT',
            SettingMessagesProduct: '6.Product',
            SettingMessagesFinance: '7.Finance',
            SettingStartsCompany: '1.Company Detail',
            SettingStartsGeneral: '2.General',
            SettingStartsStockRemains: '3.Stock Remain',
            SettingStockRemains: '2.Product Group',
            SettingStartsSellandCustomer: '4.Sell and Customer',
            SettingStartVendorMethod: '2.Payment Method',
            SettingStartsBuyandSuppliers: '5.Buy and Vendor',
            SettingStartsBanks: '6.Banking',
            SettingStartsFin: '7.Finance',
            SettingStartsAssets: '8.Asset',
            SettingAssets: '2.Group Asset',
            GeneralsDetails: '1.General',
            SettingStartsBanksDetail: 'Bank Detail',
            SettingStartsBanksName: 'Bank Name',
            Account: 'Account',
            Values: 'Values',
            Purchase: 'Purchase',
            PurchaseOrderNumber: 'Purchase Order Number',
            PurchaseOrder: 'PurchaseOrder',
            PurchaseCredit: 'PurchaseCredit',
            PurchaseAndOrder: 'PurchaseOrder/Order',
            Ports: 'Port',
            Countrys: 'Country',
            Terms: 'Term',
            Agents: 'Agent',
            Search: 'Search',
            Modes: 'Mode',
            Modessub: 'SubMode',
            Modessubmore: 'SubMode Extention',
            Choose: 'Choose',
            Supplier: 'Supplier',
            SupplierDetails: 'Supplier Detail',
            Cash: 'Cash',
            Credit: 'Credit',
            Price: 'Price',
            Details: 'Detail',
            Buy: 'Buy',
            Sell: 'Sell',
            Day: 'Day',
            Month: 'Month',
            Year: 'Year',
            Balance: 'Balance',
            Decrease: 'Decrease',
            Increase: 'Increase',
            Blockstransreport: 'Block Transection Report',
            Slabsfinalstransreport: 'Slab Complete Transection Report',
            Slabstransreport: 'Slab Transection Report',
            Report: 'Report',
            startnum: 'StartNumber',
            complete: 'Complete',
            actions: 'Action',
            confirm: 'Confirm',
            cancel: 'Cancel',
            copy: 'Copy',
            remain: 'Remain',
            scrub: 'Scrub',
            dissect: 'Dissect',
            disscrub: 'Dissect&Scrub',
            updated_at: 'Update At',
            gangsaw: 'GangSaw',
            lost: 'Lost',
            BlocksCut: 'Cutting Block',
            slabscut: 'Cutting Slab',
            cut_round: 'Round of Cut',
            import: 'Import',
            item: 'Item',
            origin: 'Origin',
            destination: 'Destination',
            types: 'Types',
            netweight: 'NetWeight',
            grossweight: 'GrossWeight',
            billoflading: 'Bill of Lading',
            marks: 'Marks',
            invoice: 'Invoice',
            shipment: 'Shipment',
            unitprice: 'UnitPrice',
            customers: 'Customer',
            CustomerDetails: 'Customer Detail',
            discount: 'Discount',
            WHT: 'WITHOLDING TAX',
            percent: 'Percent',
            Vats: 'VAT',
            calculate: 'Calculate',
            units: 'Units',
            unitsexc: 'Units Exactly',
            cbm: 'CBM',
            long: 'Long',
            width: 'Width',
            height: 'Height',
            old: 'Old',
            new: 'New',
            all: 'ALL',
            normal: 'Normal',
            relation: 'Relation',
            locations: 'Location',
            qty: 'Quantity',
            qtyexc: 'Quantity Exactly',
            ata: 'Arrival Date',
            num_of_containers: 'Number Of Containers',
            container_number: 'Container Number',
            product_group: 'Product Group',
            Block: 'Block',
            Slab: 'Slab',
            lang_po_type: 'PO Type',
            number: 'Number',
            btn_list: 'List',
            btn_save: 'Save',
            btn_add: 'Add',
            btn_edit: 'Edit',
            btn_delete: 'Delete',
            btn_submit: 'Submit',
            btn_reset: 'Reset',
            btn_lock: 'Lock',
            btn_lock_unlock: 'Lock/Unlock',
            vendors: 'Vendors',
            code: 'Code',
            name: 'Name',
            address: 'Address',
            zcode: 'Zip Code',
            editor: 'Editor',
            branch: 'Branch',
            taxid: 'TAX ID',
            created: 'Created',
            profile: 'Profile',
            stock: 'Stock',
            logout: 'Logout',
            ask_delete: 'Do you want to Delete?',
            ask_cancel: 'Do you want to Cancel?',
            ask_complete: 'Do you want to Complete?',
            del_complete: 'Delete Complete',
            del_error: 'Delete Error',
            confirm_error: 'Confirm Error',
            copy_error: 'Copy Error',
            formvalid: 'Please Enter Required Data and Correct Format',
            add_complete: 'Save Complete',
            purchaseorder: 'PurchaseOrder',
            order: 'Order',
            products: 'Products',
            ProductsDetails: 'Products Details',
            ProductsNormal: '2.Product (Stock)',
            ProductsService: '3.Product (No Stock)',
            producttypes: 'ProductType',
            RawMaterial: 'RawMaterial',
            FinishedGoods: 'FinishedGoods',
            contacts: 'Contacts',
            payments_types: 'Payment Type',
            payments_type: 'Payment Type',
            payments_number: 'Payment Number',
            currency: 'Currency',
            totalamount: 'Total Amount',
            amount: 'Amount',
            exchange: 'Exchange',
            approver: 'Approver',
            authorizer: 'Authorizer',
            authdate: 'Authentication Date',
            term: 'Term',
            status: 'Status',
            remark: 'Remark',
            credit: 'Credit',
            date: 'Date',
            arrival: 'Arrival',
            document: 'Document',
            reference: 'Reference',
        },
    ]
)